import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logos/openai-logo.svg")